<!-- 发票信息table -->
<template>
    <div>
        <el-table border :header-cell-style="{
            backgroundColor: '#FDEFE7', color: '#000000'
        }" :data="tableData" style="width: 100%">
            <el-table-column fixed="left" align="center" prop="orderMainId" label="发票订单号" width="180">
                <template slot-scope="scope">
                    <p v-for="(item, index) in scope.row.orderIds" :key="index">
                        {{ item }}
                    </p>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="name" label="发票订单生成时间" width="180">
                <template slot-scope="scope">
                    {{ scope.row.createTime | dateFormatHms }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="address" label="增值税专票费用" width="180">
            </el-table-column>
            <el-table-column align="center" prop="name" label="支付方交易单号" width="180">
            </el-table-column>
            <el-table-column align="center" prop="address" label="订单状态" width="180">
                <template slot-scope="scope">
                    {{ invoiceType[scope.row.status] }}
                </template>
            </el-table-column>
        </el-table>
        <el-table v-if="tableData.length > 0" border :header-cell-style="{
            backgroundColor: '#FDEFE7', color: '#000000'
        }" :data="tableData[0].invoicingDetailList" style="width: 100%">
            <el-table-column fixed="left" align="center" prop="date" label="发票类型" width="180">
                <template slot-scope="scope">
                    {{ invoiceType1[scope.row.type] }}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="lookUp" label="发票抬头" width="270">
            </el-table-column>
            <el-table-column align="center" prop="address" label="发票内容" width="180">
                {{ tableData[0].invoicingContent }}
            </el-table-column>
            <el-table-column align="center" prop="name" label="收票人信息" width="270">
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import Api from '../../../../../../components/Api';
export default {
    props: {
        invoicingId: {
        }
    },
    components: {},
    data() {
        return {
            tableData: [],
            invoiceType: {
                0: '待开票',
                1: '已开票',
                2: '已驳回'
            },
            invoiceType1: {
                0: '企业',
                1: '个人',
                2: '非企业性单位'
            }
        }
    },
    computed: {},
    watch: {},
    methods: {
        handleSelectionChange() { },
        //查询发票列表接口
        getQueryInvoiceList() {
            if (this.invoicingId) {
                let obj = { "page": 1, "q": { "id": null, "status": null, "id": this.invoicingId, "invoicingKinds": [] }, "size": 10 }
                new Api("user")
                    .queryInvoice(obj)
                    .then((res) => {
                        if (res.status == 200) {
                            this.tableData = res.data.records
                            this.$emit('userAddressId',this.tableData[0].userAddressId)
                        } else {
                            this.$message.error({ message: res.statusText });
                        }
                    });
            }
        },
    },
    created() {

    },
    mounted() {
        this.getQueryInvoiceList()
    },
}
</script>
<style lang='scss' scoped></style>